import {Component, computed, inject, input} from '@angular/core';
import {ChartOptions, ChartType} from 'chart.js';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'kiwi-chart',
    templateUrl: './chart.component.html',
    standalone: false
})
export class ChartComponent {
    public readonly titleKey = input<string>();
    public readonly labelKey = input<string>();
    public readonly barChartLabels = input<Array<string>>();
    public readonly barChartData = input<number[]>();
    public readonly options = input<ChartOptions>();
    public barChartOptions = computed(() => {
        const baseOptions: ChartOptions = {
            plugins: {
                legend: {
                    labels: {
                        color: 'white',
                        font: {
                            size: 14
                        }
                    }
                }
            },
            scales: {
                x: {
                    border: {
                        color: 'rgba(255,255,255,0.1)'
                    },
                    ticks: {
                        color: 'white',
                        font: {
                            size: 14
                        }
                    },
                    grid: {
                        color: 'rgba(255,255,255,0.1)'
                    }
                },
                y: {
                    border: {
                        color: 'rgba(255,255,255,0.1)'
                    },
                    ticks: {
                        color: 'white',
                        font: {
                            size: 14
                        } // TODO There used to be min: 0 here, see if this is needed
                    },
                    grid: {
                        color: 'rgba(255,255,255,0.1)'
                    }
                }
            }
        };

        const options = this.options();
        for (const optionKey in options) {
            baseOptions[optionKey] = options[optionKey];
        }
        return baseOptions;
    });
    public barChartType: ChartType = 'bar';
    private readonly translateService = inject(TranslateService);
    private readonly chartColors: Array<string> = [
        'rgba(250, 240, 220, 0.6)'
    ];
    public readonly datasets = computed(() => {
        const data = this.barChartData();
        const key = this.labelKey();
        return [{data: data, label: this.translateService.instant(key), backgroundColor: this.chartColors}]
    })
    public barChartLegend = true;
    public barChartPlugins = [];
}
